import { useEffect, useState } from 'react';
import { supabase } from '../services/supabase';

export interface ShiftStats {
  total_amount: number;
  tx_count: number;
  avg_ticket: number;
  tables_served: number;
  nfc_amount: number;
  qr_amount: number;
  cash_amount: number;
  zazu_amount: number;
  tips_total: number;
}

export function useShiftStats(storeId: string, employeeId: string) {
  const [stats, setStats] = useState<ShiftStats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!storeId || !employeeId) return;

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    supabase
      .from('orders')
      .select('total_amount, payment_method, table_id, customer_info')
      .eq('store_id', storeId)
      .eq('employee_id', employeeId)
      .gte('created_at', todayStart.toISOString())
      .then(({ data }) => {
        if (!data) { setLoading(false); return; }
        const rows = data.filter((r) => {
          const info = r.customer_info as Record<string, unknown> | null;
          return info?.source === 'tapnpay_pwa' || info?.source === 'tapnpay_staff_cash';
        });
        const total = rows.reduce((s, r) => s + ((r.total_amount as number) ?? 0), 0);
        const tables = new Set(rows.map((r) => r.table_id)).size;
        const nfc = rows.filter((r) => r.payment_method === 'tapnpay_nfc').reduce((s, r) => s + ((r.total_amount as number) ?? 0), 0);
        const qr = rows.filter((r) => r.payment_method === 'tapnpay_qr').reduce((s, r) => s + ((r.total_amount as number) ?? 0), 0);
        const cash = rows.filter((r) => r.payment_method === 'cash').reduce((s, r) => s + ((r.total_amount as number) ?? 0), 0);
        const zazu = rows.filter((r) => r.payment_method === 'zazu').reduce((s, r) => s + ((r.total_amount as number) ?? 0), 0);
        setStats({ total_amount: total, tx_count: rows.length, avg_ticket: rows.length ? total / rows.length : 0, tables_served: tables, nfc_amount: nfc, qr_amount: qr, cash_amount: cash, zazu_amount: zazu, tips_total: 0 });
        setLoading(false);
      });
  }, [storeId, employeeId]);

  return { stats, loading };
}
